import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WhyAfrica from './pages/WhyAfrica';
import Partners from './pages/Partners';
import About from './pages/About';
import Ecosystem from './pages/Ecosystem';
import Opportunity from './pages/Opportunity';
import Team from './pages/Team';
import Sankora from './pages/Sankora';
import ClimateImpact from './pages/ClimateImpact';
import './index.css';

function App() {
  return (
    <Router>
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/why-africa" element={<WhyAfrica />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="/ecosystem" element={<Ecosystem />} />
            <Route path="/opportunity" element={<Opportunity />} />
            <Route path="/team" element={<Team />} />
            <Route path="/climate-impact" element={<ClimateImpact />} />
            <Route path="/sankora" element={<Sankora />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
